module.exports = __webpack_public_path__ + "static/media/racing-unleashed-mark.7243d1b5.svg";